import { ClassroomPresenceUser, OfflineState } from "../models/classroom-presence-user";

export const groupClientsByUserId = (clients: (ClassroomPresenceUser & OfflineState)[]): Record<string, (ClassroomPresenceUser & OfflineState)[]> =>
    clients.reduce((acc, user) => {
        const userClients = acc[user.userId] ?? [];
        userClients.push(user);

        acc[user.userId] = userClients;
        return acc;
    }, {} as Record<string, (ClassroomPresenceUser & OfflineState)[]>);
